var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8754 16.904C14.6217 17.9299 13.0191 18.5455 11.2727 18.5455C7.25611 18.5455 4 15.2893 4 11.2727C4 7.25611 7.25611 4 11.2727 4C15.2893 4 18.5455 7.25611 18.5455 11.2727C18.5455 13.0191 17.9299 14.6217 16.9039 15.8755L19.787 18.7585C20.071 19.0425 20.071 19.503 19.787 19.787C19.5029 20.071 19.0425 20.071 18.7584 19.787L15.8754 16.904ZM17.0909 11.2727C17.0909 14.486 14.486 17.0909 11.2727 17.0909C8.05943 17.0909 5.45455 14.486 5.45455 11.2727C5.45455 8.05943 8.05943 5.45455 11.2727 5.45455C14.486 5.45455 17.0909 8.05943 17.0909 11.2727Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a8b528be59ab344408978ebd003ec93.svg";
export { ForwardRef as ReactComponent };